import { Backdrop, Fade, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { createContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import SchoolKycModalDetails from '../../containers/ApprovalManagement/UserKycApprove/SchoolKycModalDetails';
import {
  emptySchoolKycDetails,
  emptyUserKycDetails,
  getSchoolKycDetailsAsync,
  getSchoolKycDocDetailsAsync,
  getUserKycDetailsAsync,
  getUserKycDocDetailsAsync,
  storeSchoolKycApprovalId,
  storeSchoolKycApprovalStatus,
  storeUserKycApprovalId,
  storeUserKycApprovalStatus,
  getUserDetailsAsync,
} from '../../containers/ApprovalManagement/UserKycApprove/UserKycApproveStore/userKycApproveSlice';
import UserKycModalDetails from '../../containers/ApprovalManagement/UserKycApprove/UserKycModalDetails';

export const ApprovalModalContext = createContext(null);

const useStyles = makeStyles((theme) => ({
  premiumModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalPaper: {
    fontFamily: 'Rubik',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #fff',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 10,
  },
}));

const GenericApprovalModalProvider = ({ children }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [openApprovalModal, setOpenApprovalModal] = useState(false);
  const [approvalType, setApprovalType] = useState('');

  // const { userKycDetails } = useSelector(({ approvalReducer }) => {
  //   return {
  //     userKycDetails: approvalReducer.userKycDetails,
  //   };
  // });

  const handleOpenApprovalModal = ({ type, data }) => {
    setOpenApprovalModal(true);
    dispatch(getUserDetailsAsync({ userId: data.additionalInfo.userId }));
    switch (type) {
      case 'userKyc':
        setApprovalType('userKyc');
        dispatch(getUserKycDetailsAsync({ entityId: data._id }));
        dispatch(getUserKycDocDetailsAsync({ entityId: data.entityId }));
        break;

      case 'schoolKyc':
        setApprovalType('schoolKyc');
        dispatch(getSchoolKycDetailsAsync({ entityId: data._id }));
        dispatch(getSchoolKycDocDetailsAsync({ entityId: data.entityId }));
        break;

      default:
        break;
    }
  };
  const handleCloseApprovalModal = () => {
    if (approvalType !== '' && approvalType === 'userKyc') {
      dispatch(emptyUserKycDetails());
      dispatch(storeUserKycApprovalId(null));
      dispatch(storeUserKycApprovalStatus(null));
    }
    if (approvalType !== '' && approvalType === 'schoolKyc') {
      dispatch(emptySchoolKycDetails());
      dispatch(storeSchoolKycApprovalId(null));
      dispatch(storeSchoolKycApprovalStatus(null));
    }
    setOpenApprovalModal(false);
  };

  return (
    <ApprovalModalContext.Provider
      value={{ handleOpenApprovalModal, handleCloseApprovalModal }}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.premiumModal}
        open={openApprovalModal}
        onClose={handleCloseApprovalModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={openApprovalModal}>
          <>
            {approvalType !== '' && approvalType === 'userKyc' && (
              <UserKycModalDetails />
            )}
            {approvalType !== '' && approvalType === 'schoolKyc' && (
              <SchoolKycModalDetails />
            )}
          </>
        </Fade>
      </Modal>
      {children}
    </ApprovalModalContext.Provider>
  );
};

export default GenericApprovalModalProvider;
